import BNutritionDiet from './BNutritionDiet'

export default BNutritionDiet
